/**
 * LeadIntegrityRoute — skin-aware switcher for /lead-integrity.
 * Cockpit → LeadIntegrityCockpit · Classic → original LeadIntegrityDashboard
 *
 * `embedded` hides the inner masthead so the parent shell (e.g. Lead
 * Performance → Lead Sources → Integrity) doesn't show two titles.
 */
import { useUISkin } from "@/data/UISkinContext";
import LeadIntegrityDashboard from "./LeadIntegrityDashboard";
import LeadIntegrityCockpit from "./LeadIntegrityCockpit";

export default function LeadIntegrityRoute({ embedded = false }: { embedded?: boolean } = {}) {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <LeadIntegrityCockpit embedded={embedded} />;
  return <LeadIntegrityDashboard embedded={embedded} />;
}
